module.exports = __webpack_public_path__ + "img/1005_pc.4fd1470d.gif";